import React from 'react';
import { toJS } from 'mobx';
import { observer } from 'mobx-react';
import PropTypes from 'prop-types';
import { browserHistory } from 'react-router';
import StudentAccessFrequencyTable from './StudentAccessFrequencyTable';
import { StudentAccessFrequencyListService } from '../../services/CustomerSuccessKpiListService';
import { get } from 'lodash';

class StudentAccessFrequencyDetailTableContainer extends React.Component {
  static propTypes = {
    type: PropTypes.oneOf(['segment', 'distributor']).isRequired,
    typeId: PropTypes.string.isRequired,
  };

  constructor(props) {
    super(props);
    StudentAccessFrequencyListService.load();
  }

  render() {
    return (
      <StudentAccessFrequencyTable
        loading={
          StudentAccessFrequencyListService.fetchCurrent.fetching ||
          StudentAccessFrequencyListService.fetchPrevious.fetching
        }
        values={toJS(StudentAccessFrequencyListService.getCompaniesByType(this.props.type, this.props.typeId))}
        feedbackColorRender={StudentAccessFrequencyListService.getFeedbackColor}
        onSelect={(row) =>
          browserHistory.push(
            `/kpis/customer-success/${this.props.type}/${get(this.props, 'typeId', 'NA')}/company/${row.id}/details`
          )
        }
        formatter={StudentAccessFrequencyListService.getFormattedValue}
      />
    );
  }
}

export default observer(StudentAccessFrequencyDetailTableContainer);
